export const initialState: IAppState = {
  isLoadingFullScreen: false
};
